import React from 'react'
import PropTypes from 'prop-types'
import Skeleton from '../loaders/Skeleton';
import EmdashText from '../common/EmdashText';

const LoadingTextValue = props => {
    const { loading, value} = props;
    return (
        <div>
            { loading && 
                <Skeleton />    
            }
            { !loading && !value &&
                <EmdashText />
            }
            {!loading && value &&
                <span>{value}</span>
            }
        </div>
    )
}


LoadingTextValue.propTypes = {
    value: PropTypes.string,
    loading: PropTypes.bool
}

export default LoadingTextValue